import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, MapPin, Store, ArrowRight } from "lucide-react";
import { api, mediaUrl } from "../lib/api";
import { Seo } from "../components/Seo";

export default function Markets() {
  const [markets, setMarkets] = useState(null);
  useEffect(() => { api.get("/markets").then((r) => setMarkets(r.data.results)).catch(() => setMarkets([])); }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <Seo
        title="Marchés & événements de foodtrucks"
        description="Découvrez les marchés, festivals et rassemblements de foodtrucks près de chez vous : plusieurs camions réunis au même endroit, avec horaires et itinéraire."
        path="/marches"
      />
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 bg-street-gold/15 text-street-gold px-3 py-1 rounded-full text-sm font-bold"><Calendar size={14} /> Événements</span>
        <h1 className="text-3xl sm:text-5xl font-display font-extrabold text-urban-teal mt-4">Marchés & événements</h1>
        <p className="text-urban-teal/60 mt-3">Plusieurs foodtrucks réunis au même endroit : marchés, festivals, tournées. Trouvez où faire le plein de street food.</p>
      </div>

      {markets === null ? (
        <p className="text-center py-20 text-urban-teal/50">Chargement...</p>
      ) : markets.length === 0 ? (
        <div className="text-center py-20" data-testid="markets-empty">
          <Store size={44} className="mx-auto text-urban-teal/20" />
          <p className="text-urban-teal/50 mt-3">Aucun marché publié pour le moment. Revenez bientôt !</p>
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10" data-testid="markets-grid">
          {markets.map((m) => (
            <Link
              key={m.slug}
              to={`/marche/${m.slug}`}
              className="bg-white rounded-2xl shadow-warm overflow-hidden flex flex-col hover:shadow-warm-lg hover:-translate-y-1 transition-transform duration-200"
              data-testid={`market-card-${m.slug}`}
            >
              <div className="h-40 relative">
                {m.photo ? (
                  <img src={mediaUrl(m.photo)} alt={m.name} className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-urban-teal/5"><Store size={48} className="text-urban-teal/25" /></div>
                )}
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-street-gold text-white text-[10px] font-bold uppercase tracking-wide">{m.truck_count} foodtruck{m.truck_count > 1 ? "s" : ""}</span>
              </div>
              <div className="p-4 flex flex-col flex-1">
                <h3 className="font-display font-bold text-lg text-urban-teal leading-tight line-clamp-2">{m.name}</h3>
                {m.city && <p className="text-sm text-urban-teal/60 flex items-center gap-1 mt-1"><MapPin size={13} className="shrink-0" /> <span className="truncate">{m.city}</span></p>}
                {m.schedule && <p className="text-sm text-urban-teal/50 flex items-center gap-1 mt-1"><Calendar size={13} className="shrink-0" /> <span className="truncate">{m.schedule}</span></p>}
                <span className="mt-auto pt-3 text-street-gold font-bold text-sm flex items-center gap-1">Voir le marché <ArrowRight size={15} /></span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
